import * as yup from 'yup'

const schema = (isInternalDpo) =>
  yup.object().shape({
    sectionName: yup.string().required(),
    sectionDocument: isInternalDpo
      ? yup.string()
      : yup.string().required().cnpj('CNPJ inválido.'),
    sectionResponsibleName: yup.string().required(),
    email: yup.string().required(),
    phone: yup.string().required(),
    phone2: yup.string(),
    addressLine: yup.string().required(),
  })

export default schema
